import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { Button } from 'rmwc/Button';
import { TextField } from 'rmwc/TextField';
import ReactExport from "react-data-export";
import { ListDivider } from 'rmwc/List';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'

class AdminUserDetailsUpdate extends Component {
	constructor(props){
    super(props);
    this.state = {
    	data: {
    		userId: '',
    		email: '',
    		phone: '',
    		firstName: '',
    		lastName: '',
    		dob: '',
    	},
    	initalComponentStateDisable: true,
    	userUpdateSaveDisable: true,
    	personalInfoSaveDisable: true,
    	fetchDisable: false,
    	personalInfoErrors: {
    		firstNameError: '',
    		lastNameError: '',
    		dobError: '',
    	},
    	userInfoErrors: {
    		phoneError: '',
    		emailError: '',	
    		emailFormatError: '',

    	},
    	errorMsg: '',
    	currentDate: '',
    }
	}

	componentDidMount(){
		let  currentTime = new Date()
		let m = currentTime.getMonth() + 1
    let d = currentTime.getDate()
    let y = currentTime.getFullYear()
    let currentDate = y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d)
    this.setState({currentDate: currentDate})
	}

	onInputChange = (e) => {
		let data = Object.assign({}, this.state.data)
		data[e.target.name] = e.target.value
		this.setState({data: data})
	}

	handleClear = (e) => {
		e.preventDefault()
		let data = Object.assign({}, this.state.data)
		let userInfoErrors = Object.assign({}, this.state.userInfoErrors)
		let personalInfoErrors = Object.assign({}, this.state.personalInfoErrors)
		data.userId = ''
		data.email = ''
		data.phone = ''
		data.firstName = ''
		data.lastName = ''
		data.dob = ''
    userInfoErrors.phoneError = '',
    userInfoErrors.emailError = '',	
    userInfoErrors.emailFormatError = '',
    personalInfoErrors.firstNameError = '',
    personalInfoErrors.lastNameError = '',
    personalInfoErrors.dobError = '',
		this.setState({data: data, errorMsg: '', initalComponentStateDisable: true, userUpdateSaveDisable: true, personalInfoSaveDisable: true, userInfoErrors: userInfoErrors, personalInfoErrors: personalInfoErrors, fetchDisable: false})
	}

	fetchUserDetails = (e) => {
		let data = Object.assign({}, this.state.data)
		e.preventDefault()
		if (!data.userId){
			this.setState({errorMsg: 'User Id is Mandatory'})
			return
		}
		let url = `admin/fetch/user/details/${data.userId}`
		return api.getResponse(this.props.user.accessToken, url)
		.then((result) => {
			if(result.status === 'success'){
				data.email = result.data.email
				data.phone = result.data.phone
				data.firstName = result.data.first_name
				data.lastName = result.data.last_name
				data.dob = result.data.dob
				this.setState({data: data, errorMsg: '', initalComponentStateDisable: false, userUpdateSaveDisable: false, personalInfoSaveDisable: false, fetchDisable: true})
			}
			else if(result.status === 'error'){
				this.setState({errorMsg: result.message})
				return
			}
		}).catch((err) => {
			this.setState({errorMsg: 'Exception.Error in fetching details'})
		})
	}

	handUserDetailsChange = (e) => {
		let data = Object.assign({}, this.state.data)
		let apiInput
		let url = `admin/users/update/${data.userId}`

		if(!this.userValidForm()){

			apiInput= {
				'email' : this.state.data.email,
				'phone' : this.state.data.phone
			}
			return api.putValuesApi(this.props.user.accessToken, url, apiInput)
			.then((result) => {
				if(result.status === 'success'){
					this.setState({errorMsg: result.message, userUpdateSaveDisable: true})
				}
				else if(result.status === 'error'){
					this.setState({errorMsg: result.message})
				}
			}).catch((err) =>{
				this.setState({errorMsg: 'Exception.Error in updating the user details'})
			})
		}
	}

	handPersonalInfoDetailsChange = (e) => {
		let data = Object.assign({}, this.state.data)
		let apiInput
		let url = `admin/personal_info/update/${data.userId}`
		if(!this.personalInfoValidform()){

			apiInput =  {
				'first_name' : this.state.data.firstName,
				'last_name' : this.state.data.lastName,
				'dob' : this.state.data.dob
			}
			return api.putValuesApi(this.props.user.accessToken, url, apiInput)
			.then((result) => {
				if(result.status === 'success'){
					this.setState({errorMsg: result.message, personalInfoSaveDisable: true})
				}
				else if(result.status === 'error'){
					this.setState({errorMsg: result.message})
				}
			}).catch((err) =>{
				this.setState({errorMsg: 'Exception.Error in updating the user details'})
			})
		}
	}

	userValidForm(){
		let data = Object.assign({}, this.state.data)
		let error = false
		var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
		let errorObj = Object.assign({}, this.state.userInfoErrors)
		errorObj.emailError = ''
		errorObj.phoneError = ''
		errorObj.emailFormatError = ''
		if(!data.email){
			errorObj.emailError = 'Email is Mandatory'
			error = true
		}
		else if(data.email && (!pattern.test(this.state.data.email))){
			errorObj.emailFormatError = 'Please check email format'
			error = true
		}
		if(!data.phone){
			errorObj.phoneError = 'Phone with country code is mandatory'
			error = true
		}
		else if(data.phone.startsWith('91') && data.phone.length !== 12){
			errorObj.phoneError = 'Indian Phone number should be of 12 digits with country code'
			error = true
		}
		else if(data.phone.length < 7){
			errorObj.phoneError = 'Invalid Phone Number'
			error = true	
		}

		this.setState({userInfoErrors: errorObj})
		return error
	}

	personalInfoValidform(){
		let data = Object.assign({}, this.state.data)
		let error = false

		let errorObj = Object.assign({}, this.state.personalInfoErrors)
		errorObj.firstNameError = ''
		errorObj.lastNameError = ''
		errorObj.dobError = ''

		if(!data.firstName){
			errorObj.firstNameError = 'First Name is Mandatory'
			error = true
		}

		if(!data.lastName){
			errorObj.lastNameError = 'Last Name is Mandatory'
			error = true
		}

		// if(!data.dob){
		// 	errorObj.dobError = 'Date of Birth is Mandatory'
		// 	error = true
		// }

		this.setState({personalInfoErrors: errorObj})
		return error
	}


	render(){

		let userIdComponent
		let userDetailsComponent
		let buttonComponent
		let noteComponent

		userIdComponent = (
			<Grid>
				<GridCell span="6">
					<TextField className="text-input" type="number" label="User Id" name='userId' onChange={this.onInputChange} value={this.state.data.userId} disabled={this.state.fetchDisable}/>
					&nbsp;&nbsp;&nbsp;
					<Button raised disabled={this.state.fetchDisable} onClick={this.fetchUserDetails}>Fetch</Button>
					&nbsp;
					<Button raised onClick={this.handleClear}>Clear</Button>
				</GridCell>
			</Grid>
			)

			userDetailsComponent = (
				<Grid>
					<GridCell span="4">
						<TextField className="text-input" label="First Name" name='firstName' onChange={this.onInputChange} value={this.state.data.firstName} disabled={this.state.initalComponentStateDisable} />			
					</GridCell>
					<GridCell span="8">
						<TextField className="text-input" type="number" label="Phone" name='phone' onChange={this.onInputChange} value={this.state.data.phone} disabled={this.state.initalComponentStateDisable}/>
					</GridCell>
					<GridCell span="4">
						<TextField className="text-input" label="Last Name" name='lastName' onChange={this.onInputChange} value={this.state.data.lastName} disabled={this.state.initalComponentStateDisable} />			
					</GridCell>
					<GridCell span="8">
						<TextField className="text-input" label="Email" name='email' onChange={this.onInputChange} value={this.state.data.email} disabled={this.state.initalComponentStateDisable}/>
					</GridCell>
					<GridCell span="4">
						<TextField className="datepicker-padding" max={this.state.currentDate} type="date" label="Date of Birth" name='dob' onChange={this.onInputChange} value={this.state.data.dob} disabled={this.state.initalComponentStateDisable} />			
					</GridCell>
					<GridCell span="6">
						<Button raised onClick={this.handUserDetailsChange} disabled={this.state.userUpdateSaveDisable}>User Info Update</Button>
					</GridCell>
					<GridCell span="6">
						<Button raised onClick={this.handPersonalInfoDetailsChange} disabled={this.state.personalInfoSaveDisable}>Personal Info Update</Button>
					</GridCell>

				</Grid>
			)
			noteComponent = (
				<Grid>
					<GridCell span = "12">
							<Typography use="caption"><b>Note: </b>For Email and Phone change please click <b>USER INFO UPDATE.</b></Typography><br/>
							<Typography use="caption"><b>Note: </b>For First Name, Last Name and Date of Birth change please click <b>PERSONAL INFO UPDATE.</b></Typography><br/>
							<Typography use="caption"><b>Note: </b>Please click on <b>CLEAR</b> to enable fetch.</Typography>
					</GridCell>
				</Grid>
				)

		return(
			<div>
				<Card style={{padding: '15px'}}>
					<Grid>
						<GridCell span="12">
							<Typography use="headline6">User Details Update</Typography>
						</GridCell>
					</Grid>
				</Card>
				{userIdComponent}
				{userDetailsComponent}
				{noteComponent}
				<div>
					<GridCell span="12">
						<StatusMessage error_msg = {this.state.errorMsg}/>
						<StatusMessage error_msg = {this.state.personalInfoErrors.firstNameError} />
						<StatusMessage error_msg = {this.state.personalInfoErrors.lastNameError} />
						<StatusMessage error_msg = {this.state.personalInfoErrors.dobError} />
						<StatusMessage error_msg = {this.state.userInfoErrors.emailError} />
						<StatusMessage error_msg = {this.state.userInfoErrors.emailFormatError} />
						<StatusMessage error_msg = {this.state.userInfoErrors.phoneError} />
					</GridCell>
				</div>
			</div>
			)
	}

}
function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserDetailsUpdate);


// WEBPACK FOOTER //
// ./src/views/admin/AdminUserDetailsUpdate.jsx